import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';

class FormCaja10 extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            //Global
            cliente_sel: null,
            cuenta_opt: [],
            cuenta_sel: null,
            operacion: 'G', //G GUARDAR - M Modificar
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar
            tipoPeriodo: 'S',
            lote: null,
            //DatePicker
            fechaDesde: null,
            fechaHasta: null
        };

        this.limpiar = this.limpiar.bind(this);
        this.imprimir = this.imprimir.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.actualizarCampos = this.actualizarCampos.bind(this);
        
    }

    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0510')
         ])
        .then(( ) => {
            let fechaProceso = getFechaProcesoPorModulo('05');
            //Asignacion de Fecha
            let fechaHasta = moment(fechaProceso, 'DD/MM/YYYY')
            let fechaDesde = moment(fechaProceso, 'DD/MM/YYYY')
            
            this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta,})

        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0510');
    }
    
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    actualizarCampos(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    

    limpiar(){

        let fechaProceso = getFechaProcesoPorModulo('05');
      

        //Asignacion de Fecha
        let fechaHasta = moment(fechaProceso, 'DD/MM/YYYY')
        let fechaDesde = moment(fechaProceso, 'DD/MM/YYYY')
        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta})
    }

    imprimir(){
        try{
            let urlReportWithParams='';

            if(this.state.tipoPeriodo === 'S'){
                let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
                if (!validarFechaMomentEnFormatoString(fechaDesde)){
                    alert('La fecha Desde es inválida.');
                    return;
                }
                
                let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
                if (!validarFechaMomentEnFormatoString(fechaHasta)){
                    alert('La fecha Hasta es inválida.');
                    return;
                }

                if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                    alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                    return;
                }

        
                urlReportWithParams=`&rpt=140`; 
                urlReportWithParams+=`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
                urlReportWithParams+=`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            }else{            

                if(this.state.lote === ''){
                    alert('Debe ingresar un Número de Lote.');
                    return;
                }
                urlReportWithParams=`&rpt=140`; 
                
                let Lote = this.state.lote;
                urlReportWithParams+=`&param3=${Lote}`;
                
        }
            

            visualizarReporteEnPdf(urlReportWithParams);
            
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
                <HeaderForm>
                    <TituloForm>Retenciones Aplicada con Carga Automática</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                <Row margen_arriba={25}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Periodo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-10'>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoPeriodo' value='S' checked={this.state.tipoPeriodo==='S'} onChange={this.handleInputChange} />
                                Por Fecha
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoPeriodo' value='M' checked={this.state.tipoPeriodo==='M'} onChange={this.handleInputChange} />
                                Por Lote
                            </LabelForm>
                        </ContainerCol>
                </Row>
                <Row margen_arriba={25} isInvisible={this.state.tipoPeriodo!=='S'}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                        </ContainerCol>
                </Row>
                <Row margen_arriba={25} isInvisible={this.state.tipoPeriodo!=='M'}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Lote:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3'>
                            <InputText type='text'  name="lote"  autoComplete='off' value={this.state.lote } onChange={this.actualizarCampos}
                             />
                        </ContainerCol>
                </Row>
                
                
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimir}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormCaja10);